import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Dropzone from "react-dropzone";
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCloudUploadAlt, faInfoCircle, faExclamationCircle, faFlag } from '@fortawesome/free-solid-svg-icons';
import { NavLink, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { clearCookie, getPrivileges } from '../../../functions/Auth';
import API_PATH from "../../../constants/config.json";

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const useStyles = makeStyles((theme) => ({
    errorStatus: {
        color: '#CC0000',
        margin: '0',
        '& .statusIcon': {
          verticalAlign: 'middle',
          paddingRight: '7px',
          position: 'relative',
          top: '1px',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '20px',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
          },
        }
    },
    warningStatus: {
        margin: '0',
        '& .statusIcon': {
          color: '#CC9900',
          verticalAlign: 'middle',
          paddingRight: '7px',
          position: 'relative',
          top: '1px',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '20px',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
          },
        }
    },
    paper: {
        width: '100%',
        boxShadow: 'none',
        display: 'flex',
        margin: '0px',
    },
    importMainPanel: {
        paddingTop: '110px',
        '@media only screen and (max-width: 3500px)': {
          width: '600px',
        },
        '@media only screen and (min-width: 3501px)': {
          width: '825px',
          maxWidth: '825px',
        },
    },
    closeIcon: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        '& svg': {
          '@media only screen and (max-width: 3500px)': {
            fontSize: '16pt',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '28pt',
          },
        },
        '& :hover': {
          color: '#CC0000',
        }
    },
    signMain: {
        position: 'fixed',
        width: '100%',
        background: 'rgba(0,0,0,.5)',
        height: '100vh',
        top: '0',
        zIndex: '99',
        '& .fileListBlock': {
          width: '100%',
          background: '#fff',
          padding: '1px 0',
        },
        '& .notShowBlock': {
          display: 'none',
        }
    },
    importForm: {
        padding: '10px',
        '& h3': {
          color: '#24618E',
          marginTop: '0px',
          marginBottom: '-5px',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '18pt',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '28pt',
          },
        },
        '& .infoTag': {
          border: '1px solid #00A75D',
          borderRadius: '5px',
          padding: '5px 10px 5px',
          marginBottom: '10px',
        },
        '& .infoIcon': {
          color: '#00A75D',
          verticalAlign: 'middle',
          paddingRight: '10px',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '20pt',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '30pt',
          },
        },
        '& .infoText': {
          color: '#24618E',
        }
    },
    formLogo: {
        textAlign: 'center',
        width: '100%',
        paddingTop: '0px',
        '& p': {
          textAlign: 'right',
          width: '50px',
          float: 'right',
          position: 'relative',
          '@media only screen and (max-width: 3500px)': {
            margin: '0px 0 -20px',
          },
          '@media only screen and (min-width: 3501px)': {
            margin: '-5px 0 -20px',
            right: '10px',
          },
        },
        '& a': {
          color: '#24618E',
          '@media only screen and (max-width: 3500px)': {
            fontSize: '20pt',
          },
          '@media only screen and (min-width: 3501px)': {
            fontSize: '30pt',
          },
          '&:hover': {
            color: '#CC0000',
          }
        }
    },
    dragUploadSection: {
        width: '100%',
        border: '7px dashed #D7D7D7',
        float: 'left',
        minHeight: '350px',
        textAlign: 'center',
        '& .uploadScreenLogo': {
          color: '#D7D7D7',
          fontSize: '50px',
        },
        '&:hover': {
          border: '7px dashed #24618E',
          cursor: 'pointer',
          '& .uploadScreenLogo': {
            color: '#24618E',
          },      
        },
        '& .uploadContent': {
          paddingTop: '20%',
          '@media only screen and (max-width: 3500px)': {
            height: '330px',
          },
          '@media only screen and (min-width: 3501px)': {
            height: '500px',
          },
        }
    },
    borderImg: {
        width: '100%',
        height: '2px',
    },
    btnIcon: {
        '@media only screen and (max-width: 3500px)': {
          fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
          fontSize: '40px',
        },
    },
}));

const ImportPanel = (props) => {

    const classes = useStyles();
    let history = useHistory();
    const [fileNames, setFileNames] = React.useState([]);
    const [getCloudStorage, setCloudStorage] = React.useState(0);
    const [fileListData, setFileListData] = React.useState([]);
    const [getFileStorage, setFileStorage] = React.useState(0);

    useEffect(() => {
        if (getPrivileges().length !== 0) {
            getFileList();
            getFileSize();
        }
    }, [])

    /* This Function is used for Drag and Drop File start */
    const handleDrop = async (acceptedFiles) => {
        let importStationId = props.importStationId;
        let details = props.details;
        if (props.geojsonLayer) props.geojsonLayer.visible = false;
        if (importStationId) {
          if (props.tempView) {
            props.tempView.graphics.removeAll();
            props.tempView.zoom = 14;
          }
          props.setSearchChecked(false);
          props.setMidblockChecked(false);
          props.setIntersectionChecked(false);
        }

        let fileData = [];
        // props.setMyIndexValue(null);
        let start = new Date;
        let sleeptime = 500;
        // This Conition check files length
        let remainingArr;
        if ((details.length + acceptedFiles.length) <= API_PATH.fileUploadLimit) {
            remainingArr = acceptedFiles.length;
        } else {
            remainingArr = API_PATH.fileUploadLimit - details.length;
            if ((details.length + acceptedFiles.length) >= API_PATH.fileUploadLimit) {
                sleeptime = 20000;
            }
        }
        props.removeAllMapLocations();
        props.importRemoveLocation();
        props.setLoaderShow('block');
        props.setImportResponceValue(0);
        let fileIndex = [];
        for (let j = 0; j < remainingArr; j++) {
            setFileNames([...fileNames, ...acceptedFiles]);
            let reader = new FileReader();
            props.setShowFileList('block');
            props.getSearchWidget.disabled = true;
            let fileExe = acceptedFiles[j].name.split('.').pop();
            let droppedFileSize = acceptedFiles[j].size;
            await fileData.push(acceptedFiles[j]);
            var content = '';
            if (fileExe === 'prn' || fileExe === 'PRN' || fileExe === 'txt' || fileExe === 'TXT' || fileExe === 'csv' || fileExe === 'CSV' || fileExe === 'xls' || fileExe === 'XLS' || fileExe === 'xlsx' || fileExe === 'XLSX') {
                if (getCloudStorage > 0) {
                if (droppedFileSize <= getCloudStorage) {
                    reader.onload = async function (e) {
                    let n = 20;
                    let lines = '';
                    let mGroup;
                    lines = e.target.result.split('\n');
                    for (let line = 0; line < n; line++) {
                        if (lines[line] && lines[line] !== '') {
                        content += lines[line];
                        content += '\n';
                        }
                    }
                    // This code use for match file data using Regex 
                    for (let i = 0; i < fileListData.length; i++) {
                        let patternData = fileListData[i].pattern;
                        let file_type_id = fileListData[i].file_type_id;
                        let vendor = fileListData[i].vendor;
                        if (vendor === null) {
                        vendor = '';
                        }
                        let dataType = fileListData[i].data_type;
                        let stationId;
                        let filename = acceptedFiles[j].name;
                        if (patternData !== null) {
                        try {
                            patternData = patternData.slice(1, -1);
                            patternData = new RegExp(patternData);
                            if (patternData.test(content)) {
                            mGroup = content.match(patternData);
                            content = '';
                            stationId = mGroup[1].trim();
                            if (stationId === '' && !importStationId) {
                                await sucsessData(errorStatus, filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                            } else if (stationId === '' && importStationId) {
                                await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                            } else if (stationId !== '' && importStationId && stationId !== importStationId) {
                                await sucsessData('Warning', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'warning');
                            } else if (stationId !== '' && importStationId && stationId == importStationId) {
                                await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                            } else {
                                await sucsessData('Queued', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'success');
                            }
                            break;
                            } else {
                            if (i == fileListData.length - 1) {
                                content = '';
                                if (importStationId) {
                                await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                                } else {
                                await unSucsessData(errorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                                }
                                break;
                            }
                            }
                        } catch (e) {
                            continue;
                        }
                        } else {
                        if (i == fileListData.length - 1) {
                            content = '';
                            if (importStationId) {
                            await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                            }
                            else {
                            await unSucsessData(errorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                            }
                            break;
                        } 
                        } 
                    }
                    // This code use for match file data using Regex              
                    };
                    reader.readAsText(fileData[j], "UTF-8");
                } else {
                    reader.onload = async function (e) {
                    let n = 20;
                    let lines = '';
                    let mGroup;
                    lines = e.target.result.split('\n');
                    for (let line = 0; line < n; line++) {
                        if (lines[line] && lines[line] !== '') {
                        content += lines[line];
                        content += '\n';
                        }
                    }
                    // This code use for match file data using Regex 
                    for (let i = 0; i < fileListData.length; i++) {
                        let patternData = fileListData[i].pattern;
                        let file_type_id = fileListData[i].file_type_id;
                        let vendor = fileListData[i].vendor;
                        if (vendor === null) {
                        vendor = '';
                        }
                        let dataType = fileListData[i].data_type;
                        let stationId;
                        let filename = acceptedFiles[j].name;
                        if (patternData !== null) {
                        try {
                            patternData = patternData.slice(1, -1);
                            patternData = new RegExp(patternData);
                            if (patternData.test(content)) {
                            mGroup = content.match(patternData);
                            content = '';
                            stationId = mGroup[1].trim();

                            if (stationId === '' && !importStationId) {
                                await sucsessData(fileSizeErrorStatus, filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                            } else if (stationId === '' && importStationId) {
                                await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                            } else if (stationId !== '' && importStationId && stationId !== importStationId) {
                                await sucsessData('Warning', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                            } else if (stationId !== '' && importStationId && stationId == importStationId) {
                                await sucsessData('Queued', filename, importStationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                            } else {
                                await sucsessData('Queued', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                            }

                            // if (stationId === '') {
                            //   await sucsessData(fileSizeErrorStatus, filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                            // }
                            // else {
                            //   await sucsessData('Queued', filename, stationId, vendor, dataType, file_type_id, acceptedFiles[j], fileExe, 'error');
                            // }


                            break;
                            } else {
                            if (i == fileListData.length - 1) {
                                content = '';
                                if (importStationId) {
                                await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                                }
                                else {
                                await unSucsessData(fileSizeErrorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                                }
                                break;
                            }
                            }
                        } catch (e) {
                            continue;
                        }
                        } else {
                        if (i == fileListData.length - 1) {
                            content = '';
                            if (importStationId) {
                            await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                            } else {
                            await unSucsessData(fileSizeErrorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                            }
                            break;
                        }
                        }
                    }
                    // This code use for match file data using Regex              
                    };
                    reader.readAsText(fileData[j], "UTF-8");
                }
                }
            } else {
                if (getFileStorage > 0) {
                if (droppedFileSize <= getFileStorage) {
                    if (importStationId) {
                    await sucsessData('Queued', acceptedFiles[j].name, importStationId, '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                    } else {
                    await unSucsessData(errorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'success');
                    }
                } else {
                    await unSucsessData(fileSizeErrorStatus, acceptedFiles[j].name, '', '', 'File Storage', 5, acceptedFiles[j], fileExe, 'error');
                }
                }
            }
        }
        let time = new Date - start;
        setTimeout(function () {
            props.setLoaderShow('none');
            props.setShowimportData('block');
        }, time + 500);
        setTimeout(function () {
            history.push('/UsersDashboard');
        }, time + sleeptime);
        // This Conition check files length         
    }
    /* This Function is used for Drag and Drop File end */

    const getFileSize = () => {
        try {
          axios({
            method: 'get',
            url: API_URL + API_PATH.getFileSize,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                if (response.data && response.data.data) {
                  let fileSizeData = response.data.data;
    
                  let fileStorage = getFileFromArray(fileSizeData, "file_storage")
                  let fS = fileStorage.file_size;
                  setFileStorage(fS);
    
                  let cloudStorage = getFileFromArray(fileSizeData, "cloud_storage")
                  let cs = cloudStorage.file_size;
                  setCloudStorage(cs);
                } else {
                  setFileStorage(0);
                  setCloudStorage(0);
                }
              }
            }).catch(async function (error) {
              setFileStorage(0);
              setCloudStorage(0);
              if (error.response) {
                if (error.response.status && error.response.status == '401') {
                  if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('atexpiry');
                  }
                  history.push('/');
                }
              }
            })
        } catch (error) {
          setFileStorage(0);
          setCloudStorage(0);
          console.error(error);
        }
    }

    //This code is use for get the pattern for file reading ... start
    let fileTypeData;
    let fileArray = [];
    const getFileList = () => {
        try {
        axios({
            method: 'get',
            url: API_URL + API_PATH.fileTypeList,
        })
            .then(async function (response) {
            if (response.status && response.status == '200') {
                fileTypeData = response.data;
                fileTypeData = fileTypeData.data;
                for (let i = 0; i < fileTypeData.length; i++) {
                let fid = fileTypeData[i].file_type_id;
                let desc = fileTypeData[i].description ? fileTypeData[i].description : '';
                let patt = fileTypeData[i].pattern;
                let ven = fileTypeData[i].vendor ? fileTypeData[i].vendor : '';

                fileArray.push({ file_type_id: fid, pattern: patt, vendor: ven, data_type: desc });
                setFileListData([...fileListData, ...fileArray]);
                }

            } else {
                console.log("Do Not Get Any Station");
            }
            }).catch(async function (error) {
            if (error.response) {
                if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                    clearCookie('email');
                    clearCookie('payload');
                    clearCookie('idToken');
                    clearCookie('atexpiry');
                }
                history.push('/');
                }
            }
            })
        } catch (error) {
        console.error(error);
        }
    }
    //This code is use for get the pattern for file reading ... end

    let errorStatus = <p className={classes.errorStatus}><span className="statusIcon"><FontAwesomeIcon icon={faExclamationCircle} /></span>Error</p>;
    let warningStatus = <p className={classes.warningStatus}><span className="statusIcon"><FontAwesomeIcon icon={faFlag} /></span>Warning</p>;
    let errorStatusforStation = <p className={classes.errorStatus}><span className="statusIcon" title="This station id does not exist"><FontAwesomeIcon icon={faExclamationCircle} title="This station id does not exist" /></span>Error</p>;
    let fileSizeErrorStatus = <p className={classes.errorStatus}><span className="statusIcon" title="This file size exceeds DataPoint file size limits"><FontAwesomeIcon icon={faExclamationCircle} title="This file size exceeds DataPoint file size limits" /></span>Error</p>;
    let susData = [];
    let locData = [];
    // This function Calles Set Table Data if status Queued        
    const sucsessData = (status, fileName, stationId, vendor, dataType, file_type_id, fileBody, fileExe, file_size_status) => {
        let importStationId = props.importStationId;
        let statusCheck = errorStatus;
        let fileStatus = 'error';
        let station_id = 0;
        if (stationId !== '') {
        statusCheck = errorStatusforStation;
        }

        if (importStationId) {
            props.stationDetails.map((sid, index) => {
                statusCheck = status;
                if (importStationId === sid.stationId) {
                    station_id = sid.station_id;
                }
                if (file_size_status === 'success') {
                    fileStatus = 'success';
                } else if (file_size_status === 'warning') {
                    statusCheck = warningStatus;
                    fileStatus = 'success';
                } else {
                    statusCheck = fileSizeErrorStatus;
                }
                if (stationId === sid.stationId) {
                    locData.push({ clent_Station_id: stationId });
                    props.setMapLocation([...props.mapLocation, ...locData]);
                    let tempData = [...props.mapLocation, ...locData];
                    props.changeMapView(tempData);
                }
            });
        } else {
            props.stationDetails.map((sid, index) => {
                if (stationId === sid.stationId) {
                    statusCheck = status;
                    station_id = sid.station_id;
                    if (file_size_status === 'success') {
                        fileStatus = 'success';
                    }
                    else {
                        statusCheck = fileSizeErrorStatus;
                    }
                    locData.push({ clent_Station_id: stationId });
                    props.setMapLocation([...props.mapLocation, ...locData]);
                    let tempData = [...props.mapLocation, ...locData];
                    props.changeMapView(tempData);
                }
            });
        }

        let uniqueID = new Date().valueOf();
        susData.push({ uniqueID: uniqueID, station_id: station_id, status: statusCheck, fileName: fileName, sationId: stationId, dataType: dataType, vendor: vendor, file_status: fileStatus, file_type_id: file_type_id, file_body: fileBody, file_exe: fileExe, file_size_status: file_size_status, import_Status: 'ready', file_status_id: 0 });
        props.setDetails([...props.details, ...susData]);
    }
    // This function Calles Set Table Data if status Queued

    // This function Calles Set Table Data if status Error
    const unSucsessData = (status, fileName, stationId, vendor, dataType, file_type_id, fileBody, fileExe, file_size_status) => {
        let uniqueID = new Date().valueOf();
        susData.push({ uniqueID: uniqueID, station_id: 0, status: status, fileName: fileName, sationId: '', dataType: dataType, vendor: vendor, file_status: 'error', file_type_id: file_type_id, file_body: fileBody, file_exe: fileExe, file_size_status: file_size_status, import_Status: 'ready', file_status_id: 2 });
        props.setDetails([...props.details, ...susData]);
    }
    // This function Calles Set Table Data if status Error

    function getFileFromArray(fileArray, fileExt) {
        let temp = fileArray.find((fileEle, index) =>
          (fileEle.file_type.trim() === fileExt ||
            fileEle.file_type.trim() === fileExt.toString().toUpperCase())
        )
        return temp;
    }

    return (
        <div className={classes.dropImportData}>
            <Collapse in={props.checkedImport}>
                <Paper elevation={4} className={classes.paper} style={{ margin: '0px' }}>
                <CssBaseline />
                <div className={classes.signMain}>
                    <Container maxWidth="sm" className={classes.importMainPanel} data-testid='dragFileModal'>
                    <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '450px', paddingBottom: '10px', position: 'relative', border: '1px solid #24618E', borderRadius: '5px', width: '100%', float: 'left' }}>
                        <div className={classes.importForm}>
                        <div className={classes.formLogo}>
                            <p><NavLink className={classes.closeIcon} to='/UsersDashboard'><FontAwesomeIcon icon={faTimes} className={classes.btnIcon} /></NavLink></p>
                        </div>
                        <h3>Import Data {props.importStationId ? '- ' + props.importStationId : null}</h3>
                        <img src={require('../../../assets/images/hrimg.svg')} style={{ marginBottom: '5px' }} className={classes.borderImg} />
                        <div className='infoTag'><span className="infoIcon"><FontAwesomeIcon icon={faInfoCircle} /></span><span><a href="/file-import-requirements-and-best-practices" className="infoText" target='_blank'>File Import Requirements and Best Practices</a></span></div>
                        <div className={classes.dragUploadSection}>
                            <Dropzone
                            onDrop={handleDrop}
                            multiple={true}>
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps({ className: "dropzone" })}>
                                <input {...getInputProps()} />
                                <div className="uploadContent">
                                    <span className="uploadScreenLogo"><FontAwesomeIcon icon={faCloudUploadAlt} className="uploadIconMain" /></span><br />
                                    <span>Drag &amp; Drop Files Here</span><br />
                                    {props.details.length >= API_PATH.fileUploadLimit ?
                                    <p style={{ textAlign: 'center', margin: '10px 0 0 0', fontSize: '16pt', color: '#CC0000', display: props.fileCountData }}>Limit Exceeded !</p>
                                    : null}
                                </div>
                                </div>
                            )}
                            </Dropzone>
                        </div>
                        </div>

                    </Typography>
                    </Container>
                </div>
                </Paper>
            </Collapse>
            </div>
    )
}

export default ImportPanel;